import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { Image } from '@data/models/image.model';

@Injectable({
  providedIn: 'root',
})
export class SEOService {
  private url = 'https://gill-photography.com.au';

  private defaultImage = {
    image: this.url + '/assets/img/about.jpg',
    width: '800',
    height: '533',
  };

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private title: Title,
    private meta: Meta
  ) {}

  setMetaData(title: string, metaDesc: string, image?: Image) {
    if (!metaDesc || metaDesc.length == 0) {
      metaDesc =
        'Gill Juergens Photography - Wedding & Family Photographer in the outer eastern suburbs of Melbourne, Australia. Wedding, Newborn, Maternity, Family, Engagement, Events, and more. ';
    }

    metaDesc = this.restrictLength(metaDesc);

    this.setTitle(title);
    this.setMetaDescription(metaDesc);
    this.setRobots();
    this.setOpenGraph(title, metaDesc, image);
    this.setTwitter(title, metaDesc, image);

    // this.updateCanonicalUrl();
  }

  private setTitle(title: string) {
    const gill = `Gill Juergens Photography`;
    title == 'home' ? (title = gill) : (title += ` | ${gill}`);

    this.title.setTitle(title);
  }

  private setMetaDescription(metaDesc: string) {
    this.meta.addTag({ name: 'description', content: metaDesc });
  }

  private setRobots() {
    this.meta.addTag({ name: 'robots', content: 'index,follow' });
  }

  private setOpenGraph(title: string, metaDesc: string, image?: Image) {
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ property: 'og:description', content: metaDesc });
    this.meta.addTag({ property: 'og:type', content: 'website' });
    this.meta.addTag({ property: 'og:url', content: this.url });
    this.meta.addTag({
      property: 'og:locale',
      content: `en_AU`,
    });
    this.meta.addTag({
      property: 'og:site_name',
      content: `${title} | Gill Photography`,
    });

    const ogImage = image ? image['1024'] : this.defaultImage.image;
    const width = image ? '1024' : this.defaultImage.width;
    const height = image ? '576' : this.defaultImage.height;

    this.meta.addTag({ property: 'og:image', content: ogImage });
    this.meta.addTag({ property: 'og:image:width', content: width });
    this.meta.addTag({ property: 'og:image:height', content: height });
  }

  private setTwitter(title: string, metaDesc: string, image?: Image) {
    this.meta.addTag({ property: 'twitter:title', content: title });
    this.meta.addTag({ property: 'twitter:description', content: metaDesc });

    const twitterImage = image ? image['1024'] : this.defaultImage.image;
    const width = image ? '1024' : this.defaultImage.width;
    const height = image ? '576' : this.defaultImage.height;

    this.meta.addTag({
      property: 'twitter:image',
      content: twitterImage,
    });
    this.meta.addTag({ property: 'twitter:image:width', content: width });
    this.meta.addTag({ property: 'twitter:image:height', content: height });
  }

  // This will be done by Scully
  private updateCanonicalUrl() {
    const head = this.document.getElementsByTagName('head')[0];
    var element: HTMLLinkElement =
      this.document.querySelector(`link[rel='canonical']`) || null;
    if (element == null) {
      element = this.document.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel', 'canonical');
    element.setAttribute('href', this.document.URL);
  }

  private restrictLength(content: string) {
    if (content.length > 300) {
      content = content.slice(0, 295) + '...';
    }

    return content;
  }
}
